import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash';

const initialQuestionState = {
  question_english: '',
  question_hindi: '',
  option: [],
  entry_fee: 10,
  pred_confirm: true,
  pred_autocreate: false,
  predic_start_time: null,
  predic_end_time: null,
  slots: 200000,
  inputAnswerNumber: null,
  admin_commission: 10,
  slots_per_user:10000,
  opening_expected_winning_amount:10,
  maximum_winning_amount:20,
  minimum_winning_amount:8,
  isEdit: false,
  openSuspend: false,
  sort_number:undefined,
  join_slot_limit:100,
  for_favourite_team: 'false',
  favourite_team_id: "",
  is_global: false,
  fixed_winning: 'false',
  fixed_winning_amount: 10,
  id: 0,
  status: 0,
  id_type: 'player',
  extra_points: 0,
  is_over_under: false,
  over_runs: 0,
  correct_answer: null,
  suspend: false,
  difference: 2,
  line_red: 0,
  line_green: 0,
  stop_join: 0,
  line_red_sub: 0,
  line_green_add:0
};

export const inPlaySlice = createSlice({
  name: 'prediction',
  initialState: {
    question: [],
    modal_show: false,
    questionStates: initialQuestionState,
    isSubjective: false,
    isGlobal:false,
    globalList:[],
  },
  reducers: {
    stateRefresh: (state, action) => {
        state.questionStates = initialQuestionState
        state.isEdit =false
        state.isAdd=true
      },
    addQuestion: (state, action) => {
      state.question = [...action.payload]
    },
    modalToggle: (state, action) => {
      state.modal_show = !state.modal_show;
      state.questionStates = initialQuestionState;
      if (get(action,'payload.isSubjective', false) && state.modal_show) {
        state.isGlobal = false
        state.isSubjective = action.payload.isSubjective
        state.isSuisGlobalbjective = action.payload.isGlobal
      }else if(get(action,'payload.isGlobal', false) && state.modal_show){
        state.isSubjective =false
        state.isGlobal = action.payload.isGlobal
      }else if(state.modal_show){
        state.isSubjective = false
        state.isGlobal = false
        state.questionStates["slots"] = 1000
        state.questionStates["slots_per_user"] = 100
      }
    },
    stateValues: (state, action) => {
      state.questionStates[action.payload.name] = action.payload.value
    },
    setEditQuestion: (state, action) => {
      state.questionStates = action.payload
    },
    setGlobalList:(state,action) => {
      state.globalList = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { addQuestion, modalToggle, stateValues, setEditQuestion,setGlobalList,stateRefresh } = inPlaySlice.actions

export default inPlaySlice.reducer